const $config = {

  'feathersServer': "https://api-lb.livecasthq.com",
  'uploadServer': "api-lb.livecasthq.com/upload",
  'twilioBaseUrl': "https://api-lb.livecasthq.com/audio",
  //'feathersServer': "http://18.157.186.241:3030",

  //'uploadServer': "http://localhost:3030/upload"
  //'feathersServer': "207.154.229.158:3030",
  //'uploadServer': "167.99.244.170/upload"
  //'feathersServer': "http://161.35.20.244:3030",
  //'feathersServer': "http://localhost:3030",



}

export default $config;